import { render, staticRenderFns } from "./wizardLayout.vue?vue&type=template&id=bace193a"
import script from "./wizardLayout.vue?vue&type=script&lang=js"
export * from "./wizardLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports